// Mirrors the public DTOs' trimmed strings and Zod email/URL checks.
export function textError(value: string, label: string, min: number, max: number): string | undefined {
  const length = value.trim().length;
  if (length < min) return `${label} must be at least ${min} characters.`;
  if (length > max) return `${label} must be ${max} characters or fewer.`;
}

export function emailError(value: string, max = Infinity): string | undefined {
  if (value.trim().length > max) return `Email must be ${max} characters or fewer.`;
  if (!/^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i.test(value.trim())) {
    return 'Enter a valid email.';
  }
}

export function urlError(value: string, max: number): string | undefined {
  if (value.trim().length > max) return `URL must be ${max} characters or fewer.`;
  try { new URL(value.trim()); } catch { return 'Enter a valid URL including its scheme (e.g. https://).'; }
}

export function validateNativeForm(form: HTMLFormElement, limits: Record<string, [number, number]>): boolean {
  for (const [name, [min, max]] of Object.entries(limits)) {
    const field = form.elements.namedItem(name);
    if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement) {
      field.setCustomValidity(name === 'email' ? emailError(field.value, max) ?? '' : textError(field.value, name, min, max) ?? '');
    }
  }
  return form.reportValidity();
}
